module.exports = __webpack_public_path__ + "static/media/percent_icon.fdfea8d2.svg";